import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import GoogleMapReact from 'google-map-react';
import { useGetCollectionDetailsQuery } from './collectionRtk';
import '../driverLive/liveDriver.css';
import moment from 'moment';
import layers from '../../images/layers.png'
import Swal from 'sweetalert2';
import { useAddNewcollectionrouteMutation } from './addSlice';

const DEFAULT_CENTER = { lat: 26.8954906, lng: 75.839768 };
const DEFAULT_ZOOM = 10;
const MAP_API_KEY = 'AIzaSyBqbSNw8jtcU9MjyqXFgKdP9l9UeWqaTz8';

const ViewMapRouteAnimation = ({ id, collection_date, boundry, start_location, end_location, assignment_id }) => {
    const [mapCenter, setMapCenter] = useState(DEFAULT_CENTER);
    const [mapInstance, setMapInstance] = useState(null);
    const [googleMaps, setGoogleMaps] = useState(null);
    const [boundary, setBoundary] = useState([]);
    const [path, setPath] = useState([]);
    const [tripLocationDataPath, setTripLocationDataPath] = useState([]);
    const [vtsPathDataPath, setVtsPathDataPath] = useState([]);
    const [geoFenceRouteData, setGeoFenceRouteData] = useState([]);
    const [isAnimating, setIsAnimating] = useState(false);
    const [animationIntervalId, setAnimationIntervalId] = useState(null);
    const [truckMarker, setTruckMarker] = useState(null);
    const [tooltipData, setTooltipData] = useState(null);
    const [tooltipPosition, setTooltipPosition] = useState(null);
    const [cursorPos, setCursorPos] = useState({ x: 0, y: 0 });
    const [mapType, setMapType] = useState("ROADMAP");
    const [activePaths, setActivePaths] = useState(['a', 'b', 'c']);
    const [createPathData, setCreatePathData] = useState([]);
    const [createPathid, setCreatePathid] = useState();
    const [createPathGeoid, setCreatePathGeoid] = useState();


    const polylineRefsofflineTripPathData = useRef([]);
    const polylineRefstripLocationData = useRef([]);
    const polylineRefsvtsPathDataPath = useRef([]);
    const location = useLocation().state;

    const [addNewcollectionroute, { isLoading: isloading2 }] = useAddNewcollectionrouteMutation();

    // vehicles api 
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(`https://apis-track.ecowrap.in/track/eco-admin/v1/vehicles/path/${location?.assignment_id}`, {
                    headers: {
                        authorization: `Bearer ${(localStorage.getItem("tokenAdminPanel"))}`
                    }
                });
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const result = await response.json();
                setCreatePathGeoid(result?.data?.geoFenceRouteData[0]?.geo_id)
                setGeoFenceRouteData(result?.data?.geoFenceRouteData[0]?.location)
                setPath(result?.data?.offlineTripPathData);
                setTripLocationDataPath(result?.data?.tripLocationData);
                setVtsPathDataPath(result?.data?.vtsPathData);
            } catch (error) {
                console.log(error);
            }
        };
        fetchData();
    }, []);

    const {
        data: collectionDetails,
        isLoading: isCollectionDetailsLoading,
        isError: isCollectionDetailsError,
    } = useGetCollectionDetailsQuery({
        assignment_id: location.id,
        collection_date: location.collection_date,
    });

    useEffect(() => {
        if (mapInstance && googleMaps && boundary.length > 0) {
            const polygon = new googleMaps.Polygon({
                paths: boundary.map(point => ({ lat: point.x, lng: point.y })),
                strokeColor: '#505050',
                strokeOpacity: 1,
                strokeWeight: 2,
                fillColor: '#505050',
                fillOpacity: 0.1,
                map: mapInstance,
            });

            const bounds = new googleMaps.LatLngBounds();
            boundary.forEach(point => bounds.extend(new googleMaps.LatLng(point.lat, point.lng)));
            mapInstance.fitBounds(bounds);

            const listener = googleMaps.event.addListenerOnce(mapInstance, 'bounds_changed', () => {
                if (mapInstance.getZoom() > 16) {
                    mapInstance.setZoom(16);
                }
            });
            return () => googleMaps.event.removeListener(listener);
        }
    }, [boundary, mapInstance, googleMaps]);

    function getDistanceInMeters(lat1, lon1, lat2, lon2) {
        const R = 6371000;
        const toRad = (val) => (val * Math.PI) / 180;
        const dLat = toRad(lat2 - lat1), dLon = toRad(lon2 - lon1);
        const a = Math.sin(dLat / 2) ** 2 + Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) ** 2;
        return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    }

    // geoFenceRouteData path
    useEffect(() => {
        const pathData = [[]];

        geoFenceRouteData?.forEach((e, i) => {
            pathData[pathData.length - 1].push(e);
        });

        if (mapInstance && googleMaps && geoFenceRouteData?.length > 0) {
            pathData.forEach((segment) => {
                if (segment.length < 3) return; // Polygon needs at least 3 points

                const polygonCoordinates = segment.map(point => ({
                    lat: point?.location?.x,
                    lng: point?.location?.y
                }));

                const polygon = new googleMaps.Polygon({
                    paths: polygonCoordinates,
                    strokeColor: 'red',
                    strokeOpacity: 1.0,
                    strokeWeight: 2,
                    fillColor: '#808080',
                    fillOpacity: 0.0,
                    map: mapInstance,
                });

                polygon.addListener('mouseover', (e) => {
                    // showTimeTooltip(e.latLng);
                });

                polygon.addListener('mouseout', () => {
                    setTooltipData(null);
                    setTooltipPosition(null);
                });
            });

            const bounds = new googleMaps.LatLngBounds();
            geoFenceRouteData.forEach(point =>
                bounds.extend(new googleMaps.LatLng(point.location?.x, point.location?.y))
            );
            mapInstance.fitBounds(bounds);
        }
    }, [geoFenceRouteData, mapInstance, googleMaps, activePaths]);


    useEffect(() => {

        polylineRefsofflineTripPathData.current.forEach(polyline => { polyline.setMap(null); });

        if (!activePaths.includes('a')) {
            polylineRefsofflineTripPathData.current = [];
            return
        }

        const pathData = [[]]
        path?.forEach((e, i) => {
            let distance = getDistanceInMeters(path[i + 1]?.latitude, path[i + 1]?.longitude, e?.latitude, e?.longitude);
            if (distance > 5 && distance < 50) {
                pathData[pathData.length - 1].push(e)
            } else if (distance > 50) {
                pathData[pathData.length] = []
            }
        })

        if (mapInstance && googleMaps && path?.length > 0) {
            polylineRefsofflineTripPathData.current = [];

            pathData.map((e) => {
                let polyline = new googleMaps.Polyline({
                    path: e.map(point => ({ lat: point.latitude, lng: point.longitude })),
                    strokeColor: 'green',
                    strokeOpacity: 1.0,
                    strokeWeight: 4,
                    map: mapInstance,
                });

                polyline.addListener('mouseover', (e) => {
                    showTimeTooltip(e.latLng);
                });

                polyline.addListener('mouseout', () => {
                    setTooltipData(null);
                    setTooltipPosition(null);
                });

                polylineRefsofflineTripPathData.current.push(polyline);

                const bounds = new googleMaps.LatLngBounds();
                path.forEach(point => bounds.extend(new googleMaps.LatLng(point.latitude, point.longitude)));
                mapInstance.fitBounds(bounds);
            })
        }
    }, [path, mapInstance, googleMaps, activePaths]);

    // tripLocationData
    useEffect(() => {
        polylineRefstripLocationData.current.forEach(polyline => { polyline.setMap(null); });
        if (!activePaths.includes('b')) {
            return
        }

        const pathData = [[]]
        tripLocationDataPath?.forEach((e, i) => {
            let distance = getDistanceInMeters(
                tripLocationDataPath[i + 1]?.location?.coordinates[0],
                tripLocationDataPath[i + 1]?.location?.coordinates[1],
                e?.location?.coordinates[0],
                e?.location?.coordinates[1]
            );
            if (distance > 5 && distance < 50) {
                pathData[pathData.length - 1].push(e)
            } else if (distance > 50) {
                pathData[pathData.length] = []
            }
        })

        if (mapInstance && googleMaps && tripLocationDataPath?.length > 0) {
            polylineRefstripLocationData.current = [];

            pathData.map((e) => {
                const polyline = new googleMaps.Polyline({
                    path: e.map(point => ({ lat: point.location?.coordinates[0], lng: point.location?.coordinates[1] })),
                    strokeColor: 'blue',
                    strokeOpacity: 1.0,
                    strokeWeight: 5,
                    map: mapInstance,
                });

                polyline.addListener('mouseover', (e) => {
                    showTimeTooltip(e.latLng);
                });

                polyline.addListener('mouseout', () => {
                    setTooltipData(null);
                    setTooltipPosition(null);
                });

                polylineRefstripLocationData.current.push(polyline);

                const bounds = new googleMaps.LatLngBounds();
                tripLocationDataPath.forEach(point => bounds.extend(new googleMaps.LatLng(point.location?.coordinates[0], point.location?.coordinates[1])));
                mapInstance.fitBounds(bounds);
            })
        }
    }, [tripLocationDataPath, mapInstance, googleMaps, activePaths]);

    // vtsPathDataPath path
    useEffect(() => {
        polylineRefsvtsPathDataPath.current.forEach(polyline => { polyline.setMap(null); });
        if (!activePaths.includes('c')) {
            return
        }

        const pathData = [[]]

        vtsPathDataPath?.forEach((e, i) => {
            let distance = getDistanceInMeters(
                vtsPathDataPath[i + 1]?.location?.coordinates[0],
                vtsPathDataPath[i + 1]?.location?.coordinates[1],
                e?.location?.coordinates[0],
                e?.location?.coordinates[1]
            );
            if (distance > 5 && distance < 10000) {
                pathData[pathData.length - 1].push(e)
            } else if (distance > 50) {
                pathData[pathData.length] = []
            }
        })

        if (mapInstance && googleMaps && vtsPathDataPath?.length > 0) {
            polylineRefsvtsPathDataPath.current = [];

            pathData.map((e) => {

                const polyline = new googleMaps.Polyline({
                    path: e.map(point => ({
                        lat: point.location?.coordinates[0],
                        lng: point.location?.coordinates[1]
                    })),
                    strokeColor: 'black',
                    strokeOpacity: 1.0,
                    strokeWeight: 3,
                    map: mapInstance,
                });

                polyline.addListener('mouseover', (e) => {                    
                    showTimeTooltip(e.latLng);
                });

                polyline.addListener('mouseout', () => {
                    setTooltipData(null);
                    setTooltipPosition(null);
                });

                polylineRefsvtsPathDataPath.current.push(polyline);

                const bounds = new googleMaps.LatLngBounds();
                vtsPathDataPath.forEach(point => bounds.extend(new googleMaps.LatLng(
                    point.location?.coordinates[0],
                    point.location?.coordinates[1]
                )));
                mapInstance.fitBounds(bounds);
            })
        }
    }, [vtsPathDataPath, mapInstance, googleMaps, activePaths]);
    // }, [vtsPathDataPath, mapInstance, googleMaps]);


    function showTimeTooltip(latLng) {
        
        const nearestPoint = findNearestPoint(latLng);
        // const formattedTime = moment(nearestPoint.timeStamp).format('YYYY-MM-DD HH:mm:ss');
        // setTooltipData(formattedTime);
        // setTooltipPosition({ lat: latLng.lat(), lng: latLng.lng() });
    }
    
    function findNearestPoint(latLng) {
        let nearestPoint = collectionDetails[0];
        console.log("nearestPoint" , collectionDetails);
        // let minDistance = window.google.maps.geometry.spherical.computeDistanceBetween(latLng, new window.google.maps.LatLng(collectionDetails[0]?.x, collectionDetails[0]?.y));

        // collectionDetails.forEach(point => {
        //     const distance = window.google.maps.geometry.spherical.computeDistanceBetween(latLng, new window.google.maps.LatLng(point?.x, point?.y));
        //     if (distance < minDistance) {
        //         minDistance = distance;
        //         nearestPoint = point;
        //     }
        // });
        // return nearestPoint;
    }

    // animation path
    const animateTruck = () => {
        if (!isAnimating && truckMarker && path.length > 0 && activePaths.includes('a')) {
            let index = 0;
            const totalPoints = path.length;


            const intervalId = setInterval(() => {
                if (index < totalPoints) {
                    const currentPoint = path[index];
                    const nextPoint = path[index + 1] || currentPoint;
                    // console.log("totalPoints", currentPoint);


                    const latLng = new googleMaps.LatLng(currentPoint.latitude, currentPoint.longitude);
                    const heading = googleMaps.geometry.spherical.computeHeading(
                        new googleMaps.LatLng(currentPoint.latitude, currentPoint.longitude),
                        new googleMaps.LatLng(nextPoint.latitude, nextPoint.longitude)
                    );

                    truckMarker.setPosition(latLng);
                    truckMarker.setIcon({
                        url: getTruckIconUrl(heading),
                        scaledSize: new googleMaps.Size(40, 40),
                        anchor: new googleMaps.Point(20, 20),
                    });

                    index += 2;
                } else {
                    clearInterval(intervalId);
                    setIsAnimating(false);
                    setAnimationIntervalId(null);
                }
            }, 1000);
            setAnimationIntervalId(intervalId);
        } else if (!isAnimating && truckMarker && tripLocationDataPath.length > 0 && activePaths.includes('b')) {
            let index = 0;
            const totalPoints = tripLocationDataPath.length;


            const intervalId = setInterval(() => {
                if (index < totalPoints) {
                    const currentPoint = tripLocationDataPath[index];
                    const nextPoint = tripLocationDataPath[index + 1] || currentPoint;
                    // console.log("tripLocationDataPath", currentPoint);


                    const latLng = new googleMaps.LatLng(currentPoint.location?.coordinates[0], currentPoint.location?.coordinates[1]);
                    const heading = googleMaps.geometry.spherical.computeHeading(
                        new googleMaps.LatLng(currentPoint.location?.coordinates[0], currentPoint.location?.coordinates[1]),
                        new googleMaps.LatLng(nextPoint.location?.coordinates[0], nextPoint.location?.coordinates[1])
                    );

                    truckMarker.setPosition(latLng);
                    truckMarker.setIcon({
                        url: getTruckIconUrl(heading),
                        scaledSize: new googleMaps.Size(40, 40),
                        anchor: new googleMaps.Point(20, 20),
                    });

                    index += 2;
                } else {
                    clearInterval(intervalId);
                    setIsAnimating(false);
                    setAnimationIntervalId(null);
                }
            }, 1000);
            setAnimationIntervalId(intervalId);
        } else if (!isAnimating && truckMarker && vtsPathDataPath.length > 0 && activePaths.includes('c')) {
            let index = 0;
            const totalPoints = vtsPathDataPath.length;
            const intervalId = setInterval(() => {
                if (index < totalPoints) {
                    const currentPoint = vtsPathDataPath[index];
                    const nextPoint = vtsPathDataPath[index + 1] || currentPoint;

                    const latLng = new googleMaps.LatLng(currentPoint.location?.coordinates[0], currentPoint.location?.coordinates[1]);
                    const heading = googleMaps.geometry.spherical.computeHeading(
                        new googleMaps.LatLng(currentPoint.location?.coordinates[0], currentPoint.location?.coordinates[1]),
                        new googleMaps.LatLng(nextPoint.location?.coordinates[0], nextPoint.location?.coordinates[1])
                    );

                    truckMarker.setPosition(latLng);
                    truckMarker.setIcon({
                        url: getTruckIconUrl(heading),
                        scaledSize: new googleMaps.Size(40, 40),
                        anchor: new googleMaps.Point(20, 20),
                    });

                    index += 2;
                } else {
                    clearInterval(intervalId);
                    setIsAnimating(false);
                    setAnimationIntervalId(null);
                }
            }, 1000);
            setAnimationIntervalId(intervalId);
        }
    };

    // path Marker
    useEffect(() => {
        if (mapInstance && googleMaps && path?.length > 0) {
            const marker = new googleMaps.Marker({
                position: { lat: path[0].latitude, lng: path[0].longitude },
                map: mapInstance,
                icon: {
                    url: getTruckIconUrl(),
                    scaledSize: new googleMaps.Size(40, 40),
                    anchor: new googleMaps.Point(20, 20),
                },
            });
            setTruckMarker(marker);
        }
    }, [path, mapInstance, googleMaps]);

    // tripLocationDataPath Marker
    useEffect(() => {
        if (mapInstance && googleMaps && tripLocationDataPath?.length > 0) {
            const marker = new googleMaps.Marker({
                position: { lat: tripLocationDataPath[0].location?.coordinates[0], lng: tripLocationDataPath[0].location?.coordinates[1], },
                map: mapInstance,
                icon: {
                    url: getTruckIconUrl(),
                    scaledSize: new googleMaps.Size(40, 40),
                    anchor: new googleMaps.Point(20, 20),
                },
            });
            setTruckMarker(marker);
        }
    }, [tripLocationDataPath, mapInstance, googleMaps]);

    // vtsPathDataPath Marker
    useEffect(() => {
        if (mapInstance && googleMaps && vtsPathDataPath?.length > 0) {
            const marker = new googleMaps.Marker({
                position: { lat: vtsPathDataPath[0].location?.coordinates[0], lng: vtsPathDataPath[0].location?.coordinates[1] },
                map: mapInstance,
                icon: {
                    url: getTruckIconUrl(),
                    scaledSize: new googleMaps.Size(40, 40),
                    anchor: new googleMaps.Point(20, 20),
                },
            });
            setTruckMarker(marker);
        }
    }, [vtsPathDataPath, mapInstance, googleMaps]);

    useEffect(() => {
        if (mapInstance && googleMaps) {
            new googleMaps.Marker({
                position: { lat: location?.start_location?.lat, lng: location?.start_location?.lng },
                map: mapInstance,
                label: 'S',
                icon: {
                    url: 'http://maps.google.com/mapfiles/ms/icons/green-dot.png',
                    scaledSize: new googleMaps.Size(40, 40),
                },
            });

            new googleMaps.Marker({
                position: { lat: location?.end_location?.lat, lng: location?.end_location?.lng },
                map: mapInstance,
                label: 'E',
                icon: {
                    url: 'http://maps.google.com/mapfiles/ms/icons/red-dot.png',
                    scaledSize: new googleMaps.Size(40, 40),
                },
            });
        }
    }, [mapInstance, googleMaps, location?.start_location, location?.end_location]);

    const getTruckIconUrl = (heading = 0) => {
        const color = '#4CAF50';
        const iconSvg = `
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 200" width="100" height="200" transform="rotate(${heading})">
            <rect x="10" y="40" width="80" height="120" fill="${color}" stroke="black" stroke-width="2" />
            <rect x="20" y="10" width="60" height="30" fill="#333" stroke="black" stroke-width="2"/>
            <circle cx="20" cy="170" r="10" fill="black" />
            <circle cx="80" cy="170" r="10" fill="black" />
          </svg>`;
        return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(iconSvg)}`;
    };

    const handleToggleAnimation = () => {
        if (isAnimating) {
            clearInterval(animationIntervalId);
            setIsAnimating(false);
            setAnimationIntervalId(null);
        } else {
            setIsAnimating(true);
            animateTruck();
        }
    };

    const handleMouseMove = (e) => {
        if (tooltipData) {
            setCursorPos({ x: e.clientX, y: e.clientY });
        }
    };

    const mapView = () => {
        setMapType((e) => (e === "ROADMAP" ? "SATELLITE" : "ROADMAP"));
    };
    const createMapOptions = (maps) => {
        return { mapTypeId: maps.MapTypeId[mapType] }
    }



    // CreatePath 
    const CreatePath = async () => {
        Swal.fire({
            title: "Are you sure you want to make this collection route a permanent path? This will delete the previous path if it exists and may take up to 5 minutes.  ",
            showDenyButton: true,
            // showCancelButton: true,
            confirmButtonText: "Save",
            denyButtonText: `Don't save`
        }).then(async (result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
                try {
                    // const geo_id = location?.geo_id;
                    // const assignment_id = location?.id;
                    const assignment_id = createPathid;
                    const geo_id = createPathGeoid;

                    Swal.fire({
                        title: "Please wait...",
                        allowOutsideClick: false,
                        didOpen: () => {
                            Swal.showLoading();
                        }
                    });

                    const response = await addNewcollectionroute({ geo_id, assignment_id }).unwrap()

                    // setCreatePathData(response);
                    console.log("response", response);


                    Swal.close();
                    Swal.fire({
                        title: "Success!",
                        text: "Collection route has been saved successfully.",
                        icon: "success"
                    });
                } catch (e) {
                    console.error(e)
                }
            } else if (result.isDenied) { Swal.fire("Changes are not saved", "", "info"); }
        });
    }


    // Remove from map
    const pathhandle = (e) => {
        if (e == "a") {
            setActivePaths(['a']);
            setCreatePathid(path[0]?.assignment_id);
        } else if (e == "b") {
            setActivePaths(['b']);
            setCreatePathid(tripLocationDataPath[0]?.assignment_id);
        } else if (e == "c") {
            setActivePaths(['c']);
            setCreatePathid(vtsPathDataPath[0]?.assignment_id);
        }
    }


    return (
        <div className="container-fluid map_box" onMouseMove={handleMouseMove}>
            <div className="row mt-4">
                <div className="col-md-12 d-flex justify-content-between align-items-center">
                    <h3 className='heading_CollectionBox'>Live Location Map</h3>
                    <button className="button_all btn button_Box mb-3" onClick={handleToggleAnimation}>
                        {isAnimating ? 'Stop Animation' : 'Start Animation'}
                    </button>
                    {/* <section class="driverLive_box">
                        <div class="radio-list">
                            <div class="driverLive_list">
                                <input name="radio" onClick={() => pathhandle("a")} id="offlineTripPathData" type="radio" />
                                <label for="offlineTripPathData" style={{ color: "green" }}>OfflineTripPath</label>
                            </div>
                            <div class="driverLive_list">
                                <input name="radio" onClick={() => pathhandle("b")} id="tripLocationData" type="radio" />
                                <label for="tripLocationData" style={{ color: "blue" }}>App Path</label>
                            </div>
                            <div class="driverLive_list">
                                <input name="radio" onClick={() => pathhandle("c")} id="vtsPathData" type="radio" />
                                <label for="vtsPathData" style={{ color: "black" }}>VtsPath</label>
                            </div>
                        </div>
                    </section> */}

                </div>
                <div className="col-md-12 d-flex justify-content-between align-items-center mb-2">
                    <button className="button_all btn button_Box" onClick={CreatePath}>
                        Create path
                    </button>
                </div>

                {!isCollectionDetailsError &&
                    <div className="col-md-12" style={{ height: '67vh', width: '100%', position: 'relative' }}>
                        <GoogleMapReact
                            bootstrapURLKeys={{ key: MAP_API_KEY }}
                            defaultCenter={DEFAULT_CENTER}
                            defaultZoom={DEFAULT_ZOOM}
                            yesIWantToUseGoogleMapApiInternals
                            center={mapCenter}
                            zoom={12}
                            onGoogleApiLoaded={({ map, maps }) => {
                                setMapInstance(map);
                                setGoogleMaps(maps);
                            }}
                            options={createMapOptions}
                        >
                            <div style={{
                                position: 'fixed',
                                top: `100px`,
                                left: `-34vw`,
                            }}>
                                {<img style={{ width: "50px", height: "50px" }} src={layers} alt='Satellite' onClick={mapView} />}
                            </div>

                            <section className="driverLive_box map_pathbox">
                                <div className="radio-list">
                                    <div className="driverLive_list">
                                        <input name="radio" onClick={() => pathhandle("a")} id="offlineTripPathData" type="radio" />
                                        <label htmlFor="offlineTripPathData" style={{ color: "green" }}>OfflineTripPath</label>
                                    </div>
                                    <div className="driverLive_list">
                                        <input name="radio" onClick={() => pathhandle("b")} id="tripLocationData" type="radio" />
                                        <label htmlFor="tripLocationData" style={{ color: "blue" }}>App Path</label>
                                    </div>
                                    <div className="driverLive_list">
                                        <input name="radio" onClick={() => pathhandle("c")} id="vtsPathData" type="radio" />
                                        <label htmlFor="vtsPathData" style={{ color: "Black" }}>VtsPath</label>
                                    </div>
                                </div>
                            </section>
                        </GoogleMapReact>

                        {tooltipData && tooltipPosition && (
                            <>
                                <div
                                    style={{
                                        position: 'absolute',
                                        top: `${cursorPos.y - 150}px`,
                                        left: `${cursorPos.x}px`,
                                        backgroundColor: 'white',
                                        padding: '2vw',
                                        border: '1px solid black',
                                        borderRadius: '5px',
                                        transform: 'translate(-50%, -100%)',
                                        zIndex: 1000,
                                    }}
                                >
                                    {tooltipData}
                                </div>
                            </>
                        )}
                    </div>
                }
            </div>
        </div >
    );

};

export default ViewMapRouteAnimation;
